import { useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

export default function CookieNotice() {
  const [dismissed, setDismissed] = useState(localStorage.getItem("rb_notice_ok") === "1");
  if (dismissed) return null;
  return (
    <div data-testid="cookie-notice" className="fixed bottom-0 left-0 right-0 z-[80] bg-white border-t-2 border-foreground/15 p-4">
      <div className="max-w-5xl mx-auto flex flex-wrap items-center gap-4 justify-between">
        <p className="text-base font-semibold flex-1 min-w-[240px]">
          RoutineBuddy uses essential cookies to keep you signed in, plus privacy-friendly analytics. No advertising trackers.{" "}
          <Link to="/privacy" className="text-primary underline">Privacy policy</Link>
        </p>
        <button
          data-testid="cookie-notice-accept"
          onClick={() => { localStorage.setItem("rb_notice_ok", "1"); setDismissed(true); }}
          className="min-h-[52px] px-6 rounded-full bg-primary text-white font-bold flex items-center gap-2"
        >
          <Check size={20} strokeWidth={3} /> Got it
        </button>
      </div>
    </div>
  );
}
